import { render, staticRenderFns } from "./SpecialPlace.vue?vue&type=template&id=054449bf&scoped=true"
import script from "./SpecialPlace.vue?vue&type=script&lang=js"
export * from "./SpecialPlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054449bf",
  null
  
)

export default component.exports